<script lang="ts">
    import UserHome from "./user/UserHome.svelte";
    import PublicHome from "./public/PublicHome.svelte";
    import { get } from "svelte/store";
    import { appManager } from "./AppManager";

    let hasUser: boolean = false;

    async function getUser() {
        const store = await appManager.getCurrentUserStore();
        store.subscribe(currentUser => {
            hasUser = typeof currentUser !== "undefined";
        });
        const user = get(store);
        if (typeof user !== "undefined") {
            hasUser = true;
        } else {
            hasUser = false;
        }
    }
</script>

{#await getUser() then}
    {#if !hasUser}
        <PublicHome />
    {:else}
        <UserHome />
    {/if}
{/await}